import { InventoryModState } from "./state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations} from "./mutations";


export const defaultState: InventoryModState = {
    selectedBranchId: null,
    inventoryItems: [],
    inventoryTransactionBatch: null,
    inventoryTransactions: []
};

export const inventoryModule = {
    state: defaultState,
    mutations,
    actions, 
    getters
};